/**
 * Created by Rodrigo Quesada on 17/02/17.
 */
import {Routes, Route, ActivatedRoute, ActivatedRouteSnapshot} from '@angular/router';
import {Observable} from 'rxjs';
import {NavigableNode, NavigableNodeDeps} from './navigable-node.class';
import {Section} from './section.class';

export class SectionsServiceNode extends NavigableNode<SectionsServiceNode, Section> {

    TYPE = SectionsServiceNode;
    CHILD_TYPE = Section;

    refreshed$: Observable<boolean>;

    get currentSectionStepNumber(): number {
        return this._currentChild ? this._currentChild.currentStepNumber : 0;
    }

    get currentSectionStepsProgress(): number {
        return this._currentChild ? this._currentChild.stepsProgress : 0;
    }

    get currentSectionTitle(): string {
        return this._currentChild ? this._currentChild.title : '';
    }

    constructor(navigableNodeDeps: NavigableNodeDeps, route: Route, sections: Section[]) {
        super(navigableNodeDeps, route, sections);

        this.refreshed$ = Observable.from(sections).map(it => it.refreshed$).combineAll().map(values => (values as Array<boolean>).every(it => it));
    }

    protected _setCurrentChild(child: Section|undefined, route: ActivatedRoute) {
        super._setCurrentChild(child, route);
    }

    static fromRoutes(navigableNodeDeps: NavigableNodeDeps, routes: Routes): Observable<SectionsServiceNode> {
        return SectionsServiceNode._fromRoutes(navigableNodeDeps, SectionsServiceNode, routes);
    }

    static _fromRoute(navigableNodeDeps: NavigableNodeDeps, route: Route): Observable<SectionsServiceNode> {
        return Section.fromRoutes(navigableNodeDeps, route.children!)
            .toArray()
            .map(sections => {
                return new SectionsServiceNode(navigableNodeDeps, route, sections);
            });
    }

    refreshCurrentSection(sectionRoute: ActivatedRoute) {
        this.refreshCurrentChild(sectionRoute);
    }

    static _findAssociatedRoute(route: ActivatedRoute): ActivatedRoute|undefined {
        return route;
    }

    static _isAssociatedRoute(route: Route|ActivatedRouteSnapshot): boolean {
        return true;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/components/sections/service/sections-service-node.class.ts